import { create_instance } from '../init';

class Assets {
  getAll(data) {
    return create_instance.get('/asset', data);
  }
  get(params, data) {
    return create_instance.get('/asset/' + params, data);
  }
  getPurchased(params) {
    return create_instance.get('/asset/purchased', {
      params,
    });
    // return create_instance.get('/asset/subscribed');
  }
  getById(id) {
    return create_instance.get('/asset/guid/' + id);
  }
  delete(id) {
    return create_instance.delete('/asset/' + id);
  }
  report(params, data) {
    return create_instance.post(`/asset/${params}/report`, data);
  }
  patch(params, data) {
    return create_instance.patch('/asset/' + params, data);
  }
  addScreenshots(id) {
    return create_instance.post(`/asset/${id}/screenshots`);
  }
  updateScreenshot(params, data) {
    return create_instance.post(`/asset/${params}/screenshot`, data);
  }
  removeScreenshot(params, data) {
    return create_instance.delete(`/asset/${params}/screenshot/${data}`);
  }
  updateThumbnail(params, data) {
    return create_instance.put(`/asset/${params}/thumbnail`, data);
  }
  removeThumbnail(id) {
    return create_instance.delete(`/asset/${id}/thumbnail`);
  }
}

export default new Assets();
